<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thank you to Paul Hendey, a dear friend, for his knowledge regarding horseracing.</p>
<p>Also, to Michael Gulvardsson at Mercedes Benz in Salisbury, regarding the G Class; without him, I would have made a mistake, and to my husband, Alan, for his knowledge on military matters.</p>
<p>Thank you to Neal Caffrey and his team for their hard work and expertise.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?068605ac